/**
 * @override
 * Extends Contentful BaseHeaderFragment with `searchIdle` (Search entry) for header search flyout.
 */

import gql from 'graphql-tag';

import {BaseSearchFragment} from '@amblique/contentful/app/contentful/fragments/search/base-search.fragment';

export const BaseHeaderFragment = gql`
  ${BaseSearchFragment}

  fragment BaseHeaderFragment on Header {
    __typename
    sys {
      id
    }
    headerStyle
    siteId
    title
    searchIdle {
      ...BaseSearchFragment
    }
    searchTyping {
      ...BaseSearchFragment
    }
  }
`;
